import { Suspense } from "react";
import { makeStyles } from "@material-ui/core";
import Topics from "../header/Topics";

const useStyles = makeStyles(() => ({
	container: {
		position: 'absolute',
		right: 45,
		bottom: 14,
		zIndex: 2,
		pointerEvents: 'none',
		/* season2 を詰める場合 */
		// display: 'flex',
		// flexDirection: 'row-reverse',
		// '& > div': {
		// 	pointerEvents: 'auto',
		// },
		// '& > div:not(:first-child)': {
		// 	marginRight: 10,
		// },
		/* season2 を詰めない場合 */
		'& > div': {
			pointerEvents: 'auto',
			position: 'absolute',
			bottom: 0,
		},
	},
}));

const SeasonComment = () => {
	const classes = useStyles();
	let n = 0;
	return (
		<div id="season-container" className={classes.container}>
			<Suspense fallback={""}>
				<Topics id="season2" type="season2" tooltipPlacement="top-end" style={{ right: 50 * n++ }} />
			</Suspense>
			<Suspense fallback={""}>
				<Topics id="season3" type="season3" tooltipPlacement="top-end" style={{ right: 50 * n++ }} />
			</Suspense>
		</div>
	);
};

export default SeasonComment;
